    
export const STORE_ALL_SET = 'STORE_ALL_SET';
export const STORE_NAME_SET = 'STORE_NAME_SET';
export const LAYOUT_RESET = "LAYOUT_RESET"; // just used cause components that are linked to store settings to reload. 